import { useContext } from 'react';
import { GuardContext } from './guard-context';
export var useGuard = function () { return useContext(GuardContext); };
